import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import RichText from "@/components/RichText";
import type { ResolvedPromoContent } from "../types";
import { buildBackground } from "./promoHelpers";
import { CtaButton } from "./CtaButton";
import { PromoCountdown } from "../countdown/PromoCountdown";
interface BannerVariantProps {
  promo: ResolvedPromoContent;
  textColor: string;
  ctaBackground: string;
  ctaTextColor: string;
  href: string | null;
  isExternal: boolean;
  /** Stretch to the parent height (cells of a promo row) */
  fillHeight?: boolean;
}
export const BannerVariant: React.FC<BannerVariantProps> = t0 => {
  const $ = _c(40);
  const {
    promo,
    textColor,
    ctaBackground,
    ctaTextColor,
    href,
    isExternal,
    fillHeight: t1
  } = t0;
  const fillHeight = t1 === undefined ? false : t1;
  const t2 = `overflow-hidden rounded-lg${fillHeight ? " h-full" : ""}`;
  const t3 = `p-6 relative${fillHeight ? " h-full" : ""}`;
  let t4;
  if ($[0] !== promo) {
    t4 = buildBackground(promo, "banner");
    $[0] = promo;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t4 || $[3] !== textColor) {
    t5 = {
      background: t4,
      color: textColor
    };
    $[2] = t4;
    $[3] = textColor;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== promo.badge || $[6] !== promo.logoUrl || $[7] !== promo.name) {
    t6 = (promo.logoUrl || promo.badge) && <div className="flex flex-col items-start gap-2 md:flex-row md:justify-between md:items-center mb-4">{promo.logoUrl && <Image src={promo.logoUrl} alt={promo.name ?? ""} width={200} height={64} className="h-16 w-auto object-contain" unoptimized={true} />}{promo.badge && <div className="text-xs font-bold uppercase opacity-80">{promo.badge}</div>}</div>;
    $[5] = promo.badge;
    $[6] = promo.logoUrl;
    $[7] = promo.name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== promo.headline) {
    t7 = promo.headline && <h3 className="text-lg font-bold mb-2">{promo.headline}</h3>;
    $[9] = promo.headline;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== promo.description) {
    t8 = promo.description && <RichText content={promo.description} className="text-sm opacity-90 mb-4" />;
    $[11] = promo.description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== ctaBackground || $[14] !== ctaTextColor || $[15] !== promo.countdown || $[16] !== textColor) {
    t9 = promo.countdown && <div className="mb-4"><PromoCountdown countdown={promo.countdown} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} interactive={true} /></div>;
    $[13] = ctaBackground;
    $[14] = ctaTextColor;
    $[15] = promo.countdown;
    $[16] = textColor;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== ctaBackground || $[19] !== ctaTextColor || $[20] !== href || $[21] !== isExternal || $[22] !== promo.ctaText || $[23] !== promo.disclaimer || $[24] !== promo.highlights) {
    t10 = (promo.highlights?.length || href) && <div className={`flex flex-col gap-4 ${promo.highlights?.length ? "md:flex-row md:items-center md:justify-between" : ""}`}>{promo.highlights && promo.highlights.length > 0 && <div className="flex flex-wrap gap-3">{promo.highlights.map(_temp)}</div>}<div className={`md:shrink-0 flex flex-col items-start ${promo.highlights?.length ? "md:items-end" : ""}`}>{href && <CtaButton href={href} isExternal={isExternal} text={promo.ctaText ?? "Learn More"} backgroundColor={ctaBackground} textColor={ctaTextColor} />}{promo.disclaimer && <p className={`text-xs opacity-70 mt-2 max-w-xs ${promo.highlights?.length ? "md:text-right" : "md:text-left"}`}>{promo.disclaimer}</p>}</div></div>;
    $[18] = ctaBackground;
    $[19] = ctaTextColor;
    $[20] = href;
    $[21] = isExternal;
    $[22] = promo.ctaText;
    $[23] = promo.disclaimer;
    $[24] = promo.highlights;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t3 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t11 = <div className={t3} style={t5}>{t6}{t7}{t8}{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t3;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t2) {
    t12 = <div className={t2}>{t11}</div>;
    $[34] = t11;
    $[35] = t2;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const content = t12;
  const t13 = fillHeight ? "h-full" : undefined;
  let t14;
  if ($[37] !== content || $[38] !== t13) {
    t14 = <section className={t13}>{content}</section>;
    $[37] = content;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};
function _temp(highlight, index) {
  return <div key={index} className="bg-white/20 backdrop-blur-sm rounded-md px-3 py-2 text-center"><div className="text-lg font-bold">{highlight.value}</div><div className="text-xs opacity-80">{highlight.label}</div></div>;
}